export default "__VITE_PUBLIC_ASSET__2ffa7363__"